module.exports = __webpack_public_path__ + "img/progress-task-top-user.4adc5d47.png";